import React, { useEffect } from "react";
import PropTypes from "prop-types";
import withIntl from "../../utils/withIntl";
import {
  Button,
  createMuiTheme,
  Fade,
  MenuItem,
  MenuList,
  Paper,
  Popper,
  TextField,
  ThemeProvider,
  Typography,
} from "@material-ui/core";
import makeStyles from "@material-ui/core/styles/makeStyles";
import cloudStore from "../../store/CloudStore";

const theme = createMuiTheme({
  palette: {
    error: {
      main: "#3f51b5",
    },
  },
});

function SearchForms(props) {
  const useStyles = makeStyles({
    menuList: { overflowY: "scroll", maxHeight: "60vh", minWidth: 300 },
    section100: { width: "100%" },
    textFieldContainer: {
      display: "flex",
    },
    label: { width: "40%" },
    input: props.label ? { width: "60%" } : { width: " 100%" },
  });

  const classes = useStyles();
  const [anchorEl, setAnchorEl] = React.useState(null);
  const [searchValue, setSearchValue] = React.useState(null);
  const [options, setOptions] = React.useState([]);
  const [selectedItems] = React.useState([]);
  const { getValue } = props;

  const search = (searchValue) => {
    return new Promise((resolve, reject) => {
      const filterResults = (results) => {
        if (!results) {
          return [];
        }
        let filteredResults = results.reduce((results, resultItem) => {
          if (results.length > 19) {
            return results;
          }
          let searchValues = searchValue.split(/\s/);

          if (
            searchValues.every((value) => {
              if (value.length === 0) {
                return true;
              }
              if (getValue(resultItem).toLowerCase().includes(value.toLowerCase())) {
                return true;
              }
              return false;
            })
          ) {
            if (!selectedItems.map((item) => item.id).includes(resultItem.id)) {
              results.push(resultItem);
            }
          }
          return results;
        }, []);

        if (filteredResults.length === 0 && searchValue.length > 0 && props.createOption) {
          filteredResults.push(props.createOption(searchValue));
        }

        return filteredResults;
      };
      if (!cloudStore.merchant) {
        return [];
      }

      if (props.getResults) {
        props.getResults().then((results) => {
          resolve(filterResults(results));
          reject(filterResults(results));
        });
      } else {
        resolve(filterResults(props.allResults));
      }
    });
  };

  useEffect(() => {
    if (searchValue == null) {
      return;
    }

    let active = true;

    (async () => {
      let merchants = [];

      await search(searchValue).then((values) => {
        merchants = values;
      });

      if (active) {
        setOptions(merchants);
      }
    })();

    return () => {
      active = false;
    };
  }, [searchValue, selectedItems, props.allResults]);

  return (
    <ThemeProvider theme={theme}>
      <div className={classes.textFieldContainer}>
        {props.label && (
          <div className={classes.label}>
            <Typography>{props.label}</Typography>
            {props.helperText && <Typography>{props.helperText}</Typography>}
          </div>
        )}
        <div className={classes.input}>
          <TextField
            error={props.error ?? false}
            size={"small"}
            variant={props.variant ?? "standard"}
            fullWidth
            onFocus={(event) => {
              if (searchValue == null) {
                setSearchValue("");
              }
              setAnchorEl(anchorEl ? null : event.currentTarget);
            }}
            onBlur={(event) => {
              setAnchorEl(anchorEl ? null : event.currentTarget);
            }}
            label={props.valueVisibleAsLabel ? props.value : ""}
            value={searchValue ?? ""}
            placeholder={props.placeholder ?? ""}
            onChange={(event) => setSearchValue(event.target.value)}
            InputProps={props.InputProps != null ? props.InputProps : null}
          />
          <Popper
            placement={"bottom-start"}
            id={"popper-search-sales-area"}
            anchorEl={anchorEl}
            open={anchorEl != null}
            transition
            style={{ zIndex: 1500 }}
          >
            {({ TransitionProps }) => (
              <Fade {...TransitionProps} timeout={350}>
                <Paper>
                  <MenuList key={options.length} classes={{ root: classes.menuList }}>
                    {options.map((option, index) => (
                      <MenuItem
                        key={getValue(option) + index}
                        value={index}
                        onClick={() => {
                          setSearchValue("");
                          props.handleSelect(option);
                        }}
                      >
                        {getValue(option)}
                      </MenuItem>
                    ))}
                    {props.selectAll && (
                      <Button
                        style={{ width: "100%" }}
                        variant={"outlined"}
                        color={"primary"}
                        onClick={() => {
                          props.selectAll();
                        }}
                      >
                        Select All
                      </Button>
                    )}
                  </MenuList>
                </Paper>
              </Fade>
            )}
          </Popper>
        </div>
      </div>
    </ThemeProvider>
  );
}

SearchForms.propTypes = {
  handleSelect: PropTypes.func.isRequired,
  getResults: PropTypes.func,
  allResults: PropTypes.array,
  noResultsText: PropTypes.string.isRequired,
  label: PropTypes.string,
  placeholder: PropTypes.string,
  helperText: PropTypes.string,
  variant: PropTypes.string,
  error: PropTypes.bool,
  valueVisibleAsLabel: PropTypes.bool,
  value: PropTypes.string,
  InputProps: PropTypes.object,
  getValue: PropTypes.func,
  selectAll: PropTypes.func,
};

SearchForms.defaultProps = {
  getValue: (entry) => {
    return entry.name;
  },
};

export default withIntl(SearchForms);
